import React, {useCallback} from 'react';
import {useRouteMatch} from 'react-router';

import errorImage from '../../assets/il-question-plant.svg';
import {ErrorBoundary} from '../../components/ErrorBoundary';
import {captureError} from '../../integrations';
import * as Analytics from '../../services/analytics';
// eslint-disable-next-line import/no-cycle -- please fix if you can
import {ReportPageParams} from './ReportPageRouter';

interface ReportErrorBoundaryProps {
  editPage?: boolean;
}

const ReportErrorBoundary: React.FC<ReportErrorBoundaryProps> = React.memo(
  ({editPage = false, children}) => {
    const {params} = useRouteMatch<ReportPageParams>();

    const logError = useCallback(
      error => {
        const key = editPage ? 'ReportPageEdit' : 'ReportPageView';
        Analytics.reportPageError({
          reportMode: editPage ? 'edit' : 'view',
          reportNameAndID: params.reportNameAndID,
          entityName: params.entityName,
          projectName: params.projectName,
          errorMessage: error.message,
          errorName: error.name,
          errorStack: error.stack,
        });
        captureError(error, `${key} ErrorBoundary error`);
      },
      [params, editPage]
    );

    return (
      <ErrorBoundary renderError={renderReportError} onError={logError}>
        {children}
      </ErrorBoundary>
    );
  }
);
ReportErrorBoundary.displayName = 'ReportErrorBoundary';

function renderReportError() {
  return (
    <div className="report-page-error">
      <div className="report-page-error-content">
        <img
          className="report-page-error-image"
          src={errorImage}
          alt="confused plant"
        />
        <div className="report-page-error-text">
          <div className="report-page-error-header">
            Oops, something went wrong.
          </div>
          If this keeps happening, email us at support@wandb.com with this page
          link.
        </div>
      </div>
    </div>
  );
}

export default ReportErrorBoundary;
